export enum EStages {
    Select,
    FillContactData,
    DeliveryMethod,
    PaymentType,
    AllFilled,
}
